import React from "react";
import SignalStorageBattery from "../../../sims/ontario/signalStorageBattery";
import { Col, Row } from "reactstrap";
import moment from "moment";

export const batterySection = (testBatteryReports, selectedAsset) => {
  let modelsBatteriesReports = [];

  testBatteryReports.length > 0 &&
    testBatteryReports.map((testForm) => {
      let tableData = testForm.formData.find((field) => field && field.type === "table");
      if (tableData && tableData.value.length > 0) {
        for (let formCont of tableData.value) {
          if (!formCont.removed && formCont.form) {
            let modelVal = formCont.form.find((field) => field && field.id === "circ");
            if (modelVal) {
              let mIndex = modelsBatteriesReports.findIndex((bat) => bat.model === modelVal.value);
              if (mIndex > -1) {
                !modelsBatteriesReports[mIndex].value && (modelsBatteriesReports[mIndex].value = []);
                modelsBatteriesReports[mIndex].value.push(formCont);
              } else {
                modelsBatteriesReports.push({
                  value: [formCont],
                  model: modelVal.value,
                  title: testForm.title ? testForm.title : "Batteries Test",
                });
              }
            }
          }
        }
      }
    });
  let batReports = modelsBatteriesReports.map((batteryReport, _i) => {
    return (
      <SignalStorageBattery
        asset={selectedAsset}
        testData={batteryReport.value}
        name={batteryReport.title}
        formData={"form"}
        noTitle={true}
      />
    );
  });
  return batReports;
};



// WEBPACK FOOTER //
// ./src/components/Reports/CP/NewCrossingReport/ReportSections/batterySection.jsx